import React from "react";
import { useLocation } from "react-router-dom";
import { PageHero } from "./Section";
import { useReveal } from "../hooks/useReveal";
import Seo from "./Seo";

// Generic legal/content page: title + intro + list of {h, body} sections.
const LegalPage = ({ title, subtitle, image, sections = [] }) => {
  useReveal([sections]);
  const { pathname } = useLocation();
  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={title} description={subtitle} path={pathname} />
      <PageHero title={title} subtitle={subtitle} image={image} />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i} className="reveal">
              <h2 className="font-serif text-2xl text-wine mb-3 flex items-baseline gap-3">
                <span className="text-gold text-base font-sans">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              {Array.isArray(s.body) ? (
                <ul className="space-y-2 text-ink/70 leading-relaxed">
                  {s.body.map((line, j) => (
                    <li key={j} className="pl-4 border-l-2 border-cream-dark">{line}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-ink/70 leading-relaxed whitespace-pre-line">{s.body}</p>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
